import { UserProfileForm } from '@features/user-account/UserProfileForm';
import { useStreamV2ServerInfo } from '@hooks/useStreamV2ServerInfo';
import { Box } from '@mui/material';
import { ServerInfo } from '@protos/v2/serverinfo';
import Alert, { StyledAlertLink } from '@shared/components/Alert';
import { useUserSettingsContext } from '@shared/contexts/UserContextProvider';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Status } from '@services/StreamV2';
import { useStreamV2Status } from '@shared/hooks/useStreamV2Status';

export const ProfilePage: React.FC = () => {
  const userContext = useUserSettingsContext();
  const user = userContext?.user;
  const [streamInfo, setStreamInfo] = useState<ServerInfo>();
  const [isReadyToProcessMessages, setIsReadyToProcessMessages] = useState<boolean>(false);
  const status = useStreamV2Status();

  const onStreamInfo = useCallback((info: ServerInfo) => {
    setStreamInfo(info);
  }, []);

  useEffect(() => {
    setIsReadyToProcessMessages(status === Status.Connected);
  }, [status]);

  useStreamV2ServerInfo(onStreamInfo, isReadyToProcessMessages);

  const hasAnyWebClaim = true;

  if (!user) {
    return null;
  }

  return (
    <Box margin={2} paddingTop={2} marginTop={0}>
      {!hasAnyWebClaim && (
        <Alert error>
          You won't be able to access Flux because you are not added to a licence. Please{' '}
          <StyledAlertLink id="contact-us-no-licence-btn" component="button" color="error.main">
            <Link to="mailto:support@flux.live">Contact Support</Link>
          </StyledAlertLink>{' '}
          to find out how to be added to a licence, if you have not done so already.
        </Alert>
      )}
      <UserProfileForm user={user} streamInfo={streamInfo} />
    </Box>
  );
};
